import { CircleQuestionMark } from 'lucide-react';
import { cn } from '@/utils/style';
import { Tooltip } from './Tooltip';

interface FieldsGridProps {
  fields: FieldsGridFieldProps[];
  className?: string;
  textClassName?: string;
}

export function FieldsGrid(props: FieldsGridProps) {
  const { fields, className, textClassName } = props;

  return (
    <div className={cn('grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4', className)}>
      {fields.map((field) => (
        <FieldsGridField key={field.title} {...field} textClassName={textClassName} />
      ))}
    </div>
  );
}

interface FieldsGridFieldProps {
  title: string;
  hint?: string;
  value?: string | React.ReactNode;
  className?: string;
  textClassName?: string;
}

function FieldsGridField(props: FieldsGridFieldProps) {
  const { title, hint, value, className, textClassName } = props;

  return (
    <div className={cn('flex flex-col gap-2 h-full', className)}>
      <div className="flex items-center gap-1 text-xs font-normal text-gray-600">
        {title}
        {hint && (
          <Tooltip text={hint}>
            <CircleQuestionMark className="size-3.5 shrink-0 text-gray-400" />
          </Tooltip>
        )}
      </div>
      <div className="mt-auto">
        <div className={cn('text-sm font-medium text-gray-900 break-word', textClassName)}>
          {value || '-'}
        </div>
      </div>
    </div>
  );
}
